<div *transloco="let transloco" class="error-page">
  <img src="assets/img/broken-page.svg">
  <h1>{{ transloco('UnableLoadInvoice') }}</h1>
  <p>{{ transloco('CheckEmaiTextError') }}</p>
  <br/>
  <br/>
  <br/>
  <div *ngIf=" error.detail !== ''" class="exception">
    <h1>{{ transloco('Exception') }}</h1>
    <br/>
    <span>{{error.detail}}</span>
  </div>
</div>

